/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pre-op-time-out.reducer';

export const PreOPTimeOut = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const preOPTimeOutList = useAppSelector(state => state.preOPTimeOut.entities);
  const loading = useAppSelector(state => state.preOPTimeOut.loading);
  const totalItems = useAppSelector(state => state.preOPTimeOut.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pre-op-time-out-heading" data-cy="PreOPTimeOutHeading">
        <Translate contentKey="tinyMedicRestApp.preOPTimeOut.home.title">Pre OP Time Outs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.preOPTimeOut.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pre-op-time-out/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.preOPTimeOut.home.createLabel">Create new Pre OP Time Out</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.preOPTimeOut.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {preOPTimeOutList && preOPTimeOutList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('correctPatient')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctPatient">Correct Patient</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('correctPatient')} />
                </th>
                <th className="hand" onClick={sort('correctSiteAndSide')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctSiteAndSide">Correct Site And Side</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('correctSiteAndSide')} />
                </th>
                <th className="hand" onClick={sort('correctProcedure')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctProcedure">Correct Procedure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('correctProcedure')} />
                </th>
                <th className="hand" onClick={sort('agreementOnProcedure')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.agreementOnProcedure">Agreement On Procedure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('agreementOnProcedure')} />
                </th>
                <th className="hand" onClick={sort('correctPatientPosition')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctPatientPosition">Correct Patient Position</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('correctPatientPosition')} />
                </th>
                <th className="hand" onClick={sort('correctImplantAvailable')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctImplantAvailable">Correct Implant Available</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('correctImplantAvailable')} />
                </th>
                <th className="hand" onClick={sort('correctEquipmentAvailable')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.correctEquipmentAvailable">Correct Equipment Available</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('correctEquipmentAvailable')} />
                </th>
                <th className="hand" onClick={sort('siteMatkingVerified')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.siteMatkingVerified">Site Matking Verified</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('siteMatkingVerified')} />
                </th>
                <th className="hand" onClick={sort('relevantInvestigationsDone')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.relevantInvestigationsDone">Relevant Investigations Done</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relevantInvestigationsDone')} />
                </th>
                <th className="hand" onClick={sort('relevantImagesDone')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.relevantImagesDone">Relevant Images Done</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('relevantImagesDone')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.anaesthesiologist">Anaesthesiologist</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.surgeon">Surgeon</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOPTimeOut.scrubNurse">Scrub Nurse</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {preOPTimeOutList.map((preOPTimeOut, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pre-op-time-out/${preOPTimeOut.id}`} color="link" size="sm">
                      {preOPTimeOut.id}
                    </Button>
                  </td>
                  <td>{preOPTimeOut.correctPatient ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.correctSiteAndSide ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.correctProcedure ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.agreementOnProcedure ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.correctPatientPosition ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.correctImplantAvailable ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.correctEquipmentAvailable ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.siteMatkingVerified ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.relevantInvestigationsDone ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.relevantImagesDone ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.active ? 'true' : 'false'}</td>
                  <td>{preOPTimeOut.cursor}</td>
                  <td>{preOPTimeOut.lastupdated}</td>
                  <td>{preOPTimeOut.microSec}</td>
                  <td>{preOPTimeOut.timestampentry}</td>
                  <td>
                    {preOPTimeOut.surgery ? (
                      <Link to={`/patient-procedure/${preOPTimeOut.surgery.id}`}>{preOPTimeOut.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preOPTimeOut.anaesthesiologist ? (
                      <Link to={`/doctor/${preOPTimeOut.anaesthesiologist.id}`}>{preOPTimeOut.anaesthesiologist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{preOPTimeOut.surgeon ? <Link to={`/doctor/${preOPTimeOut.surgeon.id}`}>{preOPTimeOut.surgeon.id}</Link> : ''}</td>
                  <td>
                    {preOPTimeOut.scrubNurse ? <Link to={`/nurse/${preOPTimeOut.scrubNurse.id}`}>{preOPTimeOut.scrubNurse.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/pre-op-time-out/${preOPTimeOut.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pre-op-time-out/${preOPTimeOut.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pre-op-time-out/${preOPTimeOut.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.preOPTimeOut.home.notFound">No Pre OP Time Outs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={preOPTimeOutList && preOPTimeOutList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PreOPTimeOut;
